// extracted by mini-css-extract-plugin
export default {"scope":"_7lcEr","scope--is-breadcrumb-visible":"Ra8Eh","scope--navigation-is-open":"I87Mk","content":"q0Z6F"};